import { RouteInfo } from '../sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/developer/dashboard',
    title: 'Overview',
        icon: 'ng-tns-c1-0 icon-overall',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
  },
  {
    path: '#',
    title: 'Accounts',
    icon: 'icon-accounts',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '{{spWebUrl}}/Developer/LinkAccounts',
        title: 'Link Accounts',
        icon: '',
        class: 'second-level',
        badge: '',
        badgeClass: '',
        isExternalLink: true,
        submenu: [],
      },
      {
        path: '{{spWebUrl}}/Developer/SyncAccounts',
        title: 'Sync Accounts',
        icon: '',
        class: 'second-level',
        badge: '',
        badgeClass: '',
        isExternalLink: true,
        submenu: [],
      },
    ],
  },
  {
    path: '/developer/apps',
    title: 'My Apps',
    icon: 'ng-tns-c1-0 icon-apps',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
  },
  {
    path: '/developer/performance',
    title: 'Performance',
    icon: 'ng-tns-c1-0 icon-performance',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
  },
  {
    path: '#',
    title: 'Campaigns',
    icon: 'icon-campaigns',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '{{spWebUrl}}/Developer/UpcomingCampaigns',
        title: 'Upcoming',
        icon: '',
        class: 'second-level',
        badge: '',
        badgeClass: '',
        isExternalLink: true,
        submenu: [],
      },
      {
        path: '{{spWebUrl}}/Developer/ActiveCampaigns',
        title: 'Active',
        icon: '',
        class: 'second-level',
        badge: '',
        badgeClass: '',
        isExternalLink: true,
        submenu: [],
      },
    ],
  },
];
